import { h, Component } from 'preact';
import {Form, Container, Row, Col} from 'components/elements' 
import {connect} from 'react-redux'
import style from './style.less'
import dayjs from 'lib/helpers/dayjs';
import {FAChevronUp, FAChevronDown, FASpinner} from 'components/elements/FontAwesome'

@Form
@connect((state)=>({
	...state
}))
export default class OperatingHours extends Component {
	constructor(){
        super()
        this.state = {
            showHours: false
        }
        
        this.condensedTimes = this.condensedTimes.bind(this)
        this.toggleShowMore = this.toggleShowMore.bind(this)
    }

    get hours(){
        return this.props.hours || []
    }

    get isOpen(){
        let now = dayjs()
        for(let hour of this.hours){
            if(hour.startsAt.isBefore(now) && hour.endsAt.isAfter(now)){
                return true
            }
        }
        return false
    }

    get closeTime(){
        let now = dayjs()
        for(let hour of this.hours){
            if(hour.startsAt.isBefore(now) && hour.endsAt.isAfter(now)){
                return hour.endsAt.format("h:mm A")
            }
        }
        return ''
    }
    
    get nextOpenTime(){
        let now = dayjs()
        for(let hour of this.hours){
            if(hour.startsAt.isAfter(now)){
                return `opens on ${hour.startsAt.format("ddd")} at ${hour.startsAt.format("h:mm A")}`
            }
        }
        return ''
    }

    condensedTimes(_times){
        let timesByDay = {}
        for(let time of _times){
            let day = dayjs(time.startsAt).format('ddd')
            let startsAt = dayjs(time.startsAt).format("h:mm A")
            let endsAt = dayjs(time.endsAt).format("h:mm A")
            if(!timesByDay[day]){
                timesByDay[day] = {}
                timesByDay[day].times = [time]
                timesByDay[day].quickTime = `${startsAt}-${endsAt}`
            } else {
                timesByDay[day].times.push(time)
                timesByDay[day].quickTime += `||${startsAt}-${endsAt}`
            }
        }

        let times = []
        let days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
        for(let [i,day] of days.entries()){
            if(timesByDay[day]){
                if(!timesByDay[days[i-1]] || timesByDay[day].quickTime != timesByDay[days[i-1]].quickTime || times.length == 0){
                    times.push({
                        days: [day],
                        hours: [...timesByDay[day].times.map((t)=>{
                            return {
                                startsAt: dayjs(t.startsAt).format("h:mm A"),
                                endsAt: dayjs(t.endsAt).format("h:mm A")
                            }
                        })]
                    })
                } else {
                    let previousTime = times[times.length - 1]
                    previousTime.days.push(day)
                }
            }
        }
        return times
    }

    toggleShowMore(e){
        e.preventDefault()
        this.setState({
            showHours: !this.state.showHours
        })
    }

	render(){
		return (
            <div>
                <Container class={style.hoursContainer}>
                    <div>
                        <div class={style.hoursHeader}>
                            {this.props.header} - {this.props.spinner ? (
                                    <span class={style.spinnerContainer}>
                                        <FASpinner />
                                    </span>
                                ) : (
                                    !this.props.forceClose && this.isOpen ? (
                                        <span class={style.subHeader}><span class={style.open}>Open</span> closes at {this.closeTime}</span> 
                                    ) : (
                                        <span class={style.subHeader}><span class={style.closed}>Closed</span> {this.nextOpenTime}</span> 
                                    )
                                ) 
                            }
                        </div>
                        {this.state.showHours && 
                            this.condensedTimes(this.hours).map((time)=>(
                                <Row class={style.outerRow}>
                                    <Col span={{sm: 7}} class={[style.hoursCol, style.hoursDay]}>
                                        {time.days.length > 2 &&
                                            <span>
                                                {time.days[0]} - {time.days[time.days.length - 1]}
                                            </span>
                                        }
                                        {time.days.length <= 2 &&
                                            <span>
                                                {time.days.join(',')}
                                            </span>
                                        }
                                    </Col>
                                    <Col span={{sm: 2}}></Col>
                                    <Col span={{sm: 14}} class={[style.hoursCol, style.hoursTime]}>
                                        {time.hours.map((hour)=>(
                                            <Row class={style.innerRow}>
                                                <Col span={{sm: 24}} class={style.hoursCol}>
                                                    {hour.startsAt} - {hour.endsAt}
                                                </Col>
                                            </Row>
                                        ))}
                                    </Col>
                                </Row>
                            ))
                        }
                        {this.state.showHours ? 
                            <div class={style.showMore} onClick={this.toggleShowMore}>
                                <FAChevronUp />
                            </div>
                        :
                            <div class={style.showMore} onClick={this.toggleShowMore}>
                                <FAChevronDown />
                            </div>
                        }
                    </div>
                </Container>
            </div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/groups/OperatingHours/index.js